<div class="flex flex-col gap-2 h-[50vh]">
  <soft-ds-search-input
    class="shrink-0 mt-3 p-1"
    placeholder="Kunde suchen..."
    [value]="search()"
    (valueChange)="search.set($event ?? '')"
  />

  @if (!loading() && customers().length === 0) {
    <p class="text-sm text-light px-1 shrink-0">Keine Kunden gefunden.</p>
  } @else if (!loading()) {
    <p class="text-sm text-light px-1 shrink-0">
      {{ customers().length }}
      {{ customers().length === 1 ? 'Kunde' : 'Kunden' }} gefunden
    </p>
  } @else {
    <p class="text-sm text-light px-1 shrink-0">Lade Kunden...</p>
  }

  <div
    class="flex-1 flex flex-col gap-1.5 overflow-y-auto min-h-0 p-1"
    (scroll)="onListScroll($event)"
  >
    @if (loading()) {
      @for (_ of skeletonRows; track $index) {
        <soft-ds-item size="sm" variant="outline" class="min-h-15.5">
          <soft-ds-item-leading>
            <soft-ds-loading-skeleton [width]="32" [height]="32" [radius]="6" />
          </soft-ds-item-leading>
          <soft-ds-item-title>
            <soft-ds-loading-skeleton [width]="160" [height]="14" [radius]="4" />
          </soft-ds-item-title>
          <soft-ds-item-description>
            <soft-ds-loading-skeleton [width]="220" [height]="12" [radius]="4" />
          </soft-ds-item-description>
          <soft-ds-item-trailing>
            <soft-ds-loading-skeleton [width]="16" [height]="16" [radius]="999" />
          </soft-ds-item-trailing>
        </soft-ds-item>
      }
    }
    @for (c of customers(); track rowKey(c)) {
      <soft-ds-item
        size="sm"
        [variant]="selectedKey() === rowKey(c) ? 'default' : 'outline'"
        [class.is-selected-row]="selectedKey() === rowKey(c)"
        [interactive]="true"
        (activate)="selectCustomer(c)"
      >
        <soft-ds-item-leading>
          <span
            class="inline-flex items-center justify-center size-8 rounded-full shrink-0 text-xs font-bold"
            [class]="
              selectedKey() === rowKey(c)
                ? 'bg-primary text-white'
                : 'bg-primary/10 text-primary'
            "
          >
            {{ rowInitials(c) }}
          </span>
        </soft-ds-item-leading>
        <soft-ds-item-title>
          {{ rowName(c) }}
          <span class="text-xs text-light font-normal ml-1">{{ rowNumberLabel(c) }}</span>
        </soft-ds-item-title>
        @if (rowAddress(c); as address) {
          <soft-ds-item-description>
            <span class="inline-flex items-center gap-1">
              <soft-ds-icon name="fa-regular fa-location-dot" size="xs" color="current" />
              {{ address }}
            </span>
          </soft-ds-item-description>
        }
        <soft-ds-item-trailing>
          @if (selectedKey() === rowKey(c)) {
            <soft-ds-icon name="fa-solid fa-circle-check" size="sm" color="brand" />
          } @else {
            <soft-ds-icon
              name="fa-regular fa-circle"
              size="sm"
              color="current"
              class="opacity-20"
            />
          }
        </soft-ds-item-trailing>
      </soft-ds-item>
    }
    @if (hasMore() && !loading()) {
      <div class="flex items-center justify-center py-1 shrink-0">
        @if (loadingMore()) {
          <span class="text-sm text-light">Lade weitere Kunden...</span>
        } @else {
          <soft-ds-button
            variant="ghost"
            size="sm"
            data-testid="customer-step-load-more"
            (click)="loadMore()"
          >
            Mehr laden
          </soft-ds-button>
        }
      </div>
    }
  </div>
</div>

<ng-template #bottomTpl>
  @if (isEmbedded()) {
    <div class="flex items-center justify-end w-full mt-2! gap-2 p-1">
      <soft-ds-button
        variant="secondary"
        size="md"
        (click)="create.emit(local())"
        data-testid="customer-step-create"
      >
        {{ '#SALES.WIZARD.CREATE_DOCUMENT' | translate }}
      </soft-ds-button>
      <soft-ds-button
        variant="primary"
        size="md"
        [disabled]="!local().customer"
        (click)="confirm()"
        data-testid="customer-step-confirm"
      >
        {{ '#SALES.WIZARD.NEXT' | translate }}
        <ng-template softSlot="trailing">
          <soft-ds-icon name="fa-regular fa-arrow-right" size="sm" color="current" />
        </ng-template>
      </soft-ds-button>
    </div>
  }
</ng-template>
